/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "dfb3be783269b9e14db6519c1ab298dd0eed9af9";
